import { InjectionToken, WritableSignal } from '@angular/core';
import { Observable } from 'rxjs';
import { CampaignDto } from '../../../../common/general-types/campaigns.dto';

/** Narrow host surface the campaign store needs from CreateBriefService. */
export interface BriefBasicsCampaignHost {
  selectedCampaign: WritableSignal<CampaignDto | undefined>;
}

export const BRIEF_BASICS_CAMPAIGN_HOST = new InjectionToken<BriefBasicsCampaignHost>(
  'BRIEF_BASICS_CAMPAIGN_HOST',
);

/** Narrow campaign API used by the brief-basics campaign store. */
export interface BriefBasicsCampaignApi {
  getAllBusinessCampaigns(businessAccountId: string): Observable<CampaignDto[]>;
}

export const BRIEF_BASICS_CAMPAIGN_API = new InjectionToken<BriefBasicsCampaignApi>(
  'BRIEF_BASICS_CAMPAIGN_API',
);

/** Narrow brand context used by the brief-basics campaign store. */
export interface BriefBasicsBrandContext {
  focussedBrand: { id: string };
}

export const BRIEF_BASICS_BRAND_CONTEXT = new InjectionToken<BriefBasicsBrandContext>(
  'BRIEF_BASICS_BRAND_CONTEXT',
);
